module.exports = __webpack_public_path__ + "static/media/mechse.474fd6cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mechse.jpg
// module id = 5740
// module chunks = 0